import React from 'react';
import VideoCard from './VideoCard';
import { useState } from 'react';
import { useCodeOnce, updateCode, useVideoByIndex, increment } from '../../util/db';
import { useRouter } from '../../util/router';
import { useCallback } from 'react';

const processVideoIndex = { sb: 0, proc3: 30, proc6: 60 };
const processNames = { sb: "Stairs and Buckets", proc3: "Finding the Money", proc6: "Liability Wall" };

const ClientViewSection = () => {
  const router = useRouter()
  const [hasStarted, setHasStarted] = useState(false)
  const [selectedVideo, setSelectedVideo] = useState({})
  const [disabled, setDisabled] = useState(false)

  const {
    status: codeStatus,
    data: code,
    error: codeError,
  } = useCodeOnce(router.query.code)

  const videoIndex = processVideoIndex[code?.process] ?? 0;

  const {
    status: videosStatus,
    data: videos,
    error: videosError,
  } = useVideoByIndex(videoIndex)


  function checkExpiration(time) {
    let isValid = false
    const currentTime = new Date().getTime();
    if (currentTime - time * 1000 < 60 * 60 * 24 * 1000) {
      isValid = true
    }
    return isValid
  }

  async function beginVideo() {
    setSelectedVideo(videos.find(video => video.language === code.language) || videos[0])
    setDisabled(true)

    // Build update object with only fields that exist
    const updateData = {
      language: code.language,
      opened: true,
      owner: code.owner,
      views: code.views ? code.views + 1 : 1
    };

    // Only include method and recipients if they exist (for old send links)
    if (code.method) {
      updateData.method = code.method;
    }
    if (code.recipients) {
      updateData.recipients = code.recipients;
    }

    await updateCode(code.id, updateData)
    setHasStarted(true)
  }

  // NEW: Handle time updates from VideoCard
  const handleTimeUpdate = useCallback(async (secondsWatched) => {
    if (code?.id && secondsWatched > 0) {
      try {
        await updateCode(code.id, {
          watchSeconds: increment(secondsWatched)
        });
      } catch (error) {
        console.error('Failed to update watch time:', error);
      }
    }
  }, [code?.id]);

  return (
    <>
      {(codeStatus === "success" && code !== null && videosStatus === "success" && videosStatus.length > 0) && (
        <>
          {(checkExpiration(code.createdAt.seconds)) ? (
            <>
              <div className='container mt-4'>
                {hasStarted && (
                  <VideoCard title={selectedVideo.title} embedCode={selectedVideo.embed} description={selectedVideo.description} codeId={code.id} onTimeUpdate={handleTimeUpdate} />
                )}
                {!hasStarted && (
                  <div className="flex items-center justify-center">
                    <div className="flex flex-col items-center justify-center p-6 bg-white border border-gray-200 rounded-lg max-w-xl">
                      <h2 className="text-xl font-semibold mb-2">Ready to Watch</h2>
                      <p className="text-gray-700 mb-4">You are about to begin watching a video about {processNames[code?.process] || "Stairs and Buckets"}.</p>
                      <button disabled={disabled} onClick={() => beginVideo()} className="bg-green-500 text-white font-semibold py-2 px-4 rounded hover:bg-green-600 transition-colors duration-300">
                        Start Watching
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </>
          ) :
            <>
              <div className="text-center pt-12">
                <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">Oops, looks like this link has expired...</h1>
                <p className="mt-6 text-base leading-7 text-gray-600">Sorry, we couldn’t find the page you’re looking for. Please reach out to your agent if you would like them to send you this video again!</p>
              </div>
            </>}
        </>)}
    </>
  );
};

export default ClientViewSection;
